import React, { useEffect, useState } from "react";
import GeographyList from "./GeographyList";
import CreateGeography from "./CreateGeography";
import { toast } from "../../components/AppToast";


import {
    createGeography,
    fetchGeography,
    updateGeography
} from "../../services/geography/geography.service";


export default function GeoManagement() {

    const [geoData, setGeoData] = useState();
    const [isCreating, setIsCreating] = useState(false);
    const [activeRecord, setActiveRecord] = useState(null);

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);


    const onlyFormVisible = isCreating || !!activeRecord;

    const closeForm = () => {
        setIsCreating(false);
        setActiveRecord(null);
    };

    useEffect(() => {
        fetchGeo();
    }, [page, pageSize]);


    const fetchGeo = async () => {
        try {
            const result = await fetchGeography(page, pageSize);
            setGeoData(result);
        } catch (err) {
            console.error(err);
        }
    };


    const submitForm = async (formData, id) => {
        try {
            if (id) {
                await updateGeography(id, formData);
                toast.success("Geography updated successfully");
            } else {
                await createGeography(formData);
                toast.success("Geography created successfully");
            }

            closeForm();
            fetchGeo();
        } catch (err) {
            toast.error(err.message);
        }
    };


    return (
        <div className="card shadow-lg main-card">

            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {!onlyFormVisible
                        ? "Geography Management"
                        : isCreating
                            ? "Create Geography"
                            : activeRecord?.mode === "edit"
                                ? "Edit Geography"
                                : "View Geography"}
                </h4>
            </div>

            {onlyFormVisible && (
                <nav className="px-3 py-2 border-bottom bg-light">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item">
                            <button
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={closeForm}
                            >
                                Geography Management
                            </button>
                        </li>
                        <li className="breadcrumb-item active text-primary fw-semibold">
                            {isCreating
                                ? "Create Geography"
                                : activeRecord?.mode === "edit"
                                    ? "Edit Geography"
                                    : "View Geography"}
                        </li>
                    </ol>
                </nav>
            )}

            <div className="card-body">
                {!onlyFormVisible ? (
                    <GeographyList
                        geography={geoData}
                        page={page}
                        pageSize={pageSize}
                        setPage={setPage}
                        setPageSize={setPageSize}
                        onCreateClick={() => setIsCreating(true)}
                        onView={(row) => setActiveRecord({ mode: "view", data: row })}
                        onEdit={(row) => setActiveRecord({ mode: "edit", data: row })}
                        onRefresh={fetchGeo} 
                    />

                ) : (
                    <CreateGeography
                        initialValues={activeRecord?.data || {}}
                        onCancel={closeForm}
                        onSubmit={submitForm}
                        viewOnly={activeRecord?.mode === "view"}
                        isEdit={activeRecord?.mode === "edit"}
                    />
                )}
            </div>
        </div>
    );
}
